import React from 'react';
import { Card } from '../../types';
import PlayableCard from './PlayableCard';
import './CardGrid.css';

interface CardGridProps {
  cards: Card[];
  onCardClick: (card: Card) => void;
  disabled?: boolean;
}

const CardGrid: React.FC<CardGridProps> = ({ cards, onCardClick, disabled = false }) => {
  return (
    <div className="card-grid">
      {cards.map((card, index) => (
        <PlayableCard
          key={`${card.name}-${index}`}
          card={card}
          onClick={onCardClick}
          disabled={disabled}
        />
      ))}
    </div>
  );
};

export default CardGrid;
